import './App.css';

import { useState, useEffect, useRef } from 'react'
import { register } from "swiper/element/bundle";
import { Img } from 'react-image';
import slide1 from './assets/images/slide-1.jpg';
import slide1Desktop from './assets/images/slide-1-desktop.jpg';
import slide2 from './assets/images/slide-2.jpg';
import slide3 from './assets/images/slide-3.jpg';
import slide4 from './assets/images/slide-4.jpg';
import slide4Animation from './assets/images/slide-4-animation.gif';
import slide5 from './assets/images/slide-5.png';
import slide6 from './assets/images/slide-6.mp4';
import slide7 from './assets/images/slide-7.jpg';
import slide7Desktop from './assets/images/slide-7-desktop.jpg';
import slide8 from './assets/images/slide-8.mp4';
import slide9 from './assets/images/slide-9.jpg';
import slide9Desktop from './assets/images/slide-9-desktop.jpg';
import slide10 from './assets/images/slide-10.jpg';

// Import Swiper CSS
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";

register(); // register the custom Swiper elements

function App() {
  const [infoIsOpen, setInfoIsOpen] = useState(false);
  const [showBio, setShowBio] = useState(false);
  const [textColor, setTextColor] = useState('#FFF');
  const swiperElRef = useRef(null);

  useEffect(() => {
    const swiperEl = swiperElRef.current;

    const handleSlideChange = (e) => {
      const [swiper] = e.detail;

      // Get the currently active slide element
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      // Read its data-text-color attribute
      const color = activeSlide.dataset.textColor || '#FFF';
      // Update React state
      setTextColor(color);

      // --- 2. Handle video playback ---
      swiper.slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;

        if (index === swiper.activeIndex) {
          // Reset and play the video in the active slide
          video.currentTime = 0;
          video.play().catch(() => {}); // suppress play() promise errors if autoplay blocked
        } else {
          // Pause videos in all other slides
          video.pause();
        }
      });
    };

    const handleClick = () => {
      const swiper = swiperEl.swiper;
      if (swiper) swiper.slideNext();
    };

    const handleKeyDown = (e) => {
      const swiper = swiperEl.swiper;
      if (!swiper) return;

      if (e.key === 'ArrowRight') {
        swiper.slideNext();
      } else if (e.key === 'ArrowLeft') {
        swiper.slidePrev();
      }
    };

    // Listen for slide change event
    swiperEl.addEventListener('swiperslidechangetransitionstart', handleSlideChange);
    swiperEl.addEventListener('swiperinit', handleSlideChange);
    swiperEl.addEventListener('click', handleClick);
    window.addEventListener('keydown', handleKeyDown);
    

    // Cleanup when component unmounts
    return () => {
      swiperEl.removeEventListener('swiperslidechangetransitionstart', handleSlideChange);
      swiperEl.removeEventListener('swiperinit', handleSlideChange);
      swiperEl.removeEventListener('click', handleClick);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="App" style={{ color: infoIsOpen ? '#FFF' : textColor }}>
      <swiper-container 
        ref={swiperElRef}
        effect="fade"
        loop="true"
        speed="800"
        // autoplay-delay="3000"
        // autoplay-disable-on-interaction="true"
        fade-effect-cross-fade="true">
        <swiper-slide data-text-color="#FFF">
          <Img
            src={slide1Desktop}
            alt="Medshrum product"
            className="slide-img-full small-hide"
          />
          <Img
            src={slide1}
            alt="Medshrum product"
            className="slide-img-full large-up-hide"
          />
        </swiper-slide>
        <swiper-slide style={{ backgroundColor: '#B5ACA6' }} data-text-color="rgba(84, 78, 78, 1)">
          <Img
            src={slide2}
            alt="Medshrum product"
            className="slide-img"
          />
        </swiper-slide>
        <swiper-slide data-text-color="#FFF">
          <Img
            src={slide3}
            alt="Medshrum product"
            className="slide-img-full"
          />
        </swiper-slide>
        <swiper-slide style={{ backgroundColor: '#06514F' }} data-text-color="#FFF">
          <div className="img-wrapper">
            <Img
              src={slide4}
              alt="Medshrum product"
              className="slide-img"
            />
            <img
              src={slide4Animation}
              alt="Medshrum product"
              className="img-animation pos-absolute pos-center"
            />
          </div>
        </swiper-slide>
        <swiper-slide style={{ backgroundColor: '#009C42' }} data-text-color="rgba(84, 78, 78, 1)">
          <Img
            src={slide5}
            alt="Medshrum product"
            className="slide-img"
          />
        </swiper-slide>
        <swiper-slide style={{ backgroundColor: '#E0DBD9' }} data-text-color="rgba(84, 78, 78, 1)">
          <video className="slide-img" muted playsInline>
            <source src={slide6} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </swiper-slide>
        <swiper-slide data-text-color="#FFF">
          <Img
            src={slide7Desktop}
            alt="Medshrum product"
            className="slide-img-full small-hide"
          />
          <Img
            src={slide7}
            alt="Medshrum product"
            className="slide-img-full large-up-hide"
          />
        </swiper-slide>
        <swiper-slide style={{ backgroundColor: '#FFF' }} data-text-color="rgba(84, 78, 78, 1)">
          <video className="slide-img" autoPlay loop muted playsInline>
            <source src={slide8} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </swiper-slide>
        <swiper-slide data-text-color="#FFF">
          <Img
            src={slide9Desktop}
            alt="Medshrum product"
            className="slide-img-full small-hide"
          />
          <Img
            src={slide9}
            alt="Medshrum product"
            className="slide-img-full large-up-hide"
          />
        </swiper-slide>
        <swiper-slide style={{ backgroundColor: '#E0DBD9' }} data-text-color="rgba(84, 78, 78, 1)">
          <Img
            src={slide10}
            alt="Medshrum product"
            className="slide-img"
          />
        </swiper-slide>
      </swiper-container>

      <div className="header">
        <h2>
          <button onClick={() => setShowBio(current => !current)} className="bio-button">dapple</button>
        </h2>

        <p className={`bio ${showBio ? 'is-active' : ''}`}>A design agency specialising in<br/>Hospitality and FMCG sectors</p>
      </div>

      <button onClick={() => setInfoIsOpen(current => !current)} className="info-button">{infoIsOpen ? 'Close' : 'Info'}</button>

      <div className={`info-container ${infoIsOpen ? 'is-open' : ''}`}>
        <div className="info-container__bg" onClick={() => setInfoIsOpen(false)}>&nbsp;</div>
        <div className="info-container__content">
          <h4>Enquiries:</h4>
          <p><a href="mailto:hi@dapple.studio">hi@dapple.studio</a></p>
          <h4>Instagram:</h4>
          <p><a href="https://www.instagram.com/dapple.studio/">@dapple.studio</a></p>
          <p>Dapple Studio Limited<br/>Company No. 10861886<br/>VAT No. 284791752</p>
        </div>
      </div>
    </div>
  );
}

export default App;
